<template>
    <div class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl ">
                    Sites bans
                </div>
                <button class="btn btn--outline-primary btn--middle" @click="showCustomModal('client-ban', 1)">+ Add New</button>
                <AddNewItemModal
                    title="Add Site Name"
                    confirm-text="Save"
                    :id="getCustomModalId('client-ban', 1)"
                    reject-text="Cancel"
                    type="select"
                    :positions="clientsList"
                    @confirm="banApplicant"
                ></AddNewItemModal>
            </div>
            <div class="table-holder table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th>
                            <nobr>
                                <a href="javascript:void(0)" @click.prevent="changeSortList('client')">Site Name<i class="fas fa-sort"></i></a>
                            </nobr>
                        </th>
                        <th>
                            <nobr>
                                <a href="javascript:void(0)" @click.prevent="changeSortList('admin')">Banned by<i class="fas fa-sort"></i></a>
                            </nobr>
                        </th>
                        <th>
                            Date
                        </th>
                        <th class="text-right"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="site in siteBans"
                        :key="site.id"
                    >
                        <td>
                            <b>
                                {{ site.client.name }}
                            </b>
                        </td>
                        <td>{{site.banned_by.name ?? ''}} {{site.banned_by.last_name ?? ''}}</td>
                        <td>
                            <div class="color--text-gray">
                              {{calculateDate(site.created_at)}}
                            </div>
                        </td>
                        <td class="text-right">
                            <div class="action-block">
                                <button
                                    class="img-btn delete-link"
                                    @click="showDeleteModal(site.id, 'client')"
                                ><img src="/img/svg/on.svg" alt=""></button>
                                <ActionModal confirm-text="Yes"
                                             reject-text="No"
                                             :modalId="getDeleteModalId(site.id, 'client')"
                                             @confirm="deleteSiteBans(site.id)">
                                    <template #body>
                                        <div class="text-center mb-4">
                                            <h4>
                                                Are you sure you want <br> to delete this item?
                                            </h4>
                                        </div>
                                    </template>
                                </ActionModal>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-between">
                <Pagination
                    class="ml-1 mr-1"
                    :currentPage="pagination.current_page"
                    :lastPage="pagination.last_page"
                    @changeItemsPerPage="changeItemsPerPage"
                    @changePage="changePage"/>
            </div>
        </div>
    </div>

</template>

<script>
import ApplicantsServices from "../services/ApplicantsServices";
import AddNewItemModal from "../../../../../../resources/js/components/AddNewItemModal.vue";
import SiteClientsService from "../../../../SitesClients/resources/js/services/SiteClientsService";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import CommonService from "../../../../AppUser/resources/js/services/CommonService";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import SortDirectionHandler from "../../../../../../resources/js/mixins/SortDirectionHandler";
import Pagination from "../../../../../../resources/js/components/Pagination.vue";

export default {
    name: 'SiteBans',
    components: {Pagination, ActionModal, AddNewItemModal},
    props: {
        userId: {
            type: Number
        }
    },
    mixins: [DateConverter, ModalHandler, PaginationHandler, SortDirectionHandler],
    data() {
       return {
           siteBans: [],
           clientsList: [],
           filters: {
               sortBy: 'client',
               sortDir: 'asc',
               page: 1,
               perPage: 10
           },
           pagination: {
               current_page: 1,
               last_page: 1,
           },
       }
    },
    methods: {
        getList(filters) {
            this.getApplicantSiteBansInfo(filters)
        },
        async banApplicant(item) {
            if (!item) {
                this.$showErrorMessage('Please select a site')
                return
            }
            this.$showLoadingMessage()
             try {
                    await ApplicantsServices.addSiteBans(this.userId, item);
                    await this.getApplicantSiteBansInfo()
                    this.$showSuccessMessage('The employee was banned');
                } catch (error) {
                    console.error(error);
                 this.$showErrorMessage('The employee was not banned. Please reload page and try again')
                }
        },
        async deleteSiteBans(id) {
            this.$showLoadingMessage()
            this.siteBans = this.siteBans.filter((site) => site.id !== id)
            try {
                await SiteClientsService.deleteEmployee(id)
                this.$showSuccessMessage('The employee was reinstated');
            } catch (error) {
                this.$showErrorMessage('The employee is still banned. Please reload page and try again');
            }
        },
        async getApplicantSiteBansInfo() {
            try {
                const {data: response} = await ApplicantsServices.getApplicantSiteBans(this.userId, this.filters)
                this.siteBans = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Sites was not uploaded')
            }
        },
        async getClientsList() {
            const {data: response} = await CommonService.getClientsList()
            this.clientsList = response
        },
    },
    mounted() {
        this.getApplicantSiteBansInfo()
        this.getClientsList()
    }
}

</script>

<style scoped>

</style>
